module.exports = __webpack_public_path__ + "8b3cfb9bad6be63b8920dec79cb0d808.svg";